//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is the property of 6over6 Ltd. and its licensors. Any use of the Software is strictly prohibited unless an explicit license or permission is granted by 6over6 Ltd.
import { MockActions } from "./MockActions.js";

class _mockService {
  constructor() {
    this.mockActions = MockActions;
    this.currentStageIndex = 0;
    this.pageTranstionDelay = 200;
  }

  getNextStage() {
    if (this.currentStageIndex < this.mockActions.length) {
      let nextStage = this.mockActions[this.currentStageIndex];
      this.currentStageIndex += 1;
      if (this.currentStageIndex === this.mockActions.length) {
        console.log("moving to final stage: ", nextStage.stage);
      } else {
        console.log("moving to stage: ", nextStage.stage);
      }
      return nextStage;
    } else {
      console.log("Last stage was called. Please refresh the page to restart.");
      return null;
    }
  }
}

const MockService = new _mockService();
export default MockService;
